<div class="layout-container">
  <app-menu (menuToggled)="onMenuToggled($event)" />
  <app-loader *ngIf="loader" title="Loading" message="Bringing the purple vibes…" variant="dots" size="md">
  </app-loader>
  <div class="content-area" [class.pt-0]="selectedCutomerId" [class.menu-collapsed]="menuCollapsed()">
    @if (!selectedCutomerId && !loader) {
    <div class="grid-section">
      <div class="d-flex align-items-center">
        <nav class="breadcrumb-nav">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <a [routerLink]="'/crm'">{{ 'CRM' }}</a>
            </li>
            <li class="breadcrumb-item active">{{ 'ADVANCE CRM' }}</li>
          </ol>
        </nav>
        <div class="d-flex export-buttons">
          <button class="export-excel me-4" (click)="exportToExcel()"><span>Excel</span><i
              class="fa-solid fa-download"></i></button>
          <button class="export-excel export-pdf me-4" (click)="exportToPDF()"><span>PDF</span><i
              class="fa-solid fa-download"></i></button>
          <div class="search-section">
            <input type="text" placeholder="Search by" (input)="onSearchChange()" [(ngModel)]="searchText" />
          </div>
        </div>
      </div>
      <div class="position-relative">
        <div class="overflow-hide"></div>
        <!-- <div class="overflow-right"></div> -->
        <!-- <div class="overflow-left"></div> -->
        <ng-scrollbar class="">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>BUSINESS NAME</th>
                <th>LOCATION</th>
                <th>EMAIL</th>
                <th>WALLET BALANCE</th>
                <th>BOOKINGS</th>
                <th>CURRENCY</th>
                <th>LAST LOGIN</th>
                <!-- <th >STATUS</th> -->
                <th scope="col" class="" (click)="toggleDatesDropdown('status')">{{currentStatus || 'STATUS'}}
                  <i class="fa-solid fa-angle-up arrow cursor-pointer" *ngIf="this.isDropdownOpen['status']"></i>
                  <i class="fa-solid fa-angle-down arrow cursor-pointer" *ngIf="!this.isDropdownOpen['status']"></i>
                  <div class="dropdown-content" *ngIf="isDropdownOpen['status']">
                    <ul class="text-uppercase text-center">
                      <li (click)="filterStatus('all')">All</li>
                      <li (click)="filterStatus(2)">Active</li>
                      <li (click)="filterStatus(1)">Partial Active</li>
                      <li (click)="filterStatus(0)">Inactive</li>
                    </ul>
                  </div>
                </th>
                <th>CREATED DATE</th>
                <!-- <th>ACTION</th> -->
              </tr>
            </thead>
            <tbody>
              <tr (mouseenter)="hoverIndex = i" (mouseleave)="hoverIndex = -1" (click)="openEditCRM(customer.id)"
                class="my-5" *ngFor="let customer of allCustomers; let i = index">
                <td >{{ customer?.id }}</td>
                <td class="ellipsis-text" >{{ customer?.businessName }}</td>
                <td class="ellipsis-text" >{{ customer?.location || 'NA' }}</td>
                <td class="ellipsis-text" >{{ customer?.email }}</td>
                <td>{{ customer?.walletBalance?.toFixed(2) || 0 }}</td>
                <td>{{ customer?.bookings || 0 }}</td>
                <td>{{ customer?.currency || 'GBP' }}</td>
                <td *ngIf="customer?.lastLogin" >{{ customer?.lastLogin | date: 'dd MMMM yy, hh:mm a' }}</td>
                <td *ngIf="!customer?.lastLogin" >{{ 'NA' }}</td>
                <td [ngStyle]="{
                    'color': customer.status === 0 ? '#C03030' :
                    customer.status === 1 ? '#111' :
                    customer.status === 2 ? '#a2c030' : 'defaultColor'
                  }">{{ customer.status === 0 ? 'INACTIVE' : (customer.status === 1 ? 'PARTIAL ACTIVE' : (customer.status
                  === 2 ? 'ACTIVE' : customer.status)) }}
                <td>{{ customer?.createdDate | date: 'dd MMMM yy' }}</td>
                <!-- <td><button class="back-to-grid" (click)="openModal(customer, 'modal-md',  deletePopup)"><i
                      class="text-danger fa fa-trash-can"></i></button></td> -->
              </tr>
            </tbody>
          </table>
          <div *ngIf="allCustomers.length < 1" class="d-flex h-100 justify-content-center align-items-center"><app-no-result></app-no-result></div>
        </ng-scrollbar>
        </div>

    </div>
    <div *ngIf="!loader" class="pagination-container" [class.pagination-collapsed]="menuCollapsed()">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <span>Go To Page</span>
          <div class="d-flex align-items-center ms-2">
            <form class="d-flex align-items-center" [formGroup]="pageForm">
              <input min="1" max="{{customerData?.totalPages}}" formControlName="value" />
            </form>
            <button class="" (click)="onPageChange(pageForm.value.value)"><i
                class="fa-solid fa-arrow-right"></i></button>
          </div>
        </div>
        <ngb-pagination class="m-0" [collectionSize]="customerData?.totalElements" [(page)]="currentPage"
          [rotate]="true" [boundaryLinks]="true" [pageSize]="customerData?.size" [maxSize]="maxsize"
          (pageChange)="onPageChange($event)">
          <ng-template ngbPaginationFirst>First</ng-template>
          <ng-template ngbPaginationPrevious>Prev</ng-template>
          <ng-template ngbPaginationNext>Next</ng-template>
          <ng-template ngbPaginationLast>Last</ng-template>
        </ngb-pagination>
      </div>
    </div>
    }
    @if (selectedCutomerId && !loader && allCustomers.length > 0) {
    <div class="crm-container pt-0">
      <!-- Header -->
      <button class="back-to-grid"><i (click)="backToCrm()" class="fa fa-arrow-left-long"></i></button>
      <div class="crm-header">
        <div class="header-left">
          <h2 class="head-color">Advance CRM</h2>
          <span class="company-name base-color">{{ selectedCutomer.userAccInfo.companyName }}</span>
        </div>
        <div class="header-right">
          <div class="user-info">
            <span class="user-name head-color">{{ selectedCutomer.userAccInfo.firstName }} {{
              selectedCutomer.userAccInfo.lastName }}</span>
            <div class="balance-info">
              <span class="balance">Balance: {{ formatCurrency(selectedCutomer.walletInfo.balance,
                selectedCutomer.walletInfo.currency) }} +</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Navigation Tabs -->
      <div class="nav-tabs">
        <button class="nav-tab" [class.active]="activeSection === 'registration'"
          (click)="setActiveSection('registration')">
          Account Details
        </button>
        <button class="nav-tab" [class.active]="activeSection === 'wallet'" (click)="setActiveSection('wallet')">
          Wallet Section
        </button>
        <button class="nav-tab" [class.active]="activeSection === 'user-search'" (click)="setActiveSection('user-search')">
          User Search History
        </button>
        <button class="nav-tab" [class.active]="activeSection === 'user-request'"
          (click)="setActiveSection('user-request')">
          User Active Request
        </button>
        <button *ngIf="role != 'AGENT'" class="nav-tab" [class.active]="activeSection === 'active-suppliers'"
          (click)="setActiveSection('active-suppliers')">
          Active Suppliers
        </button>
        <button class="nav-tab" [class.active]="activeSection === 'setup'" (click)="setActiveSection('setup')">
          Set Up Form
        </button>
      </div>

      <!-- Main Content -->
      <div class="main-content" [class.main-register]="activeSection === 'registration'">

        <!-- Registration Info Section -->
        <div *ngIf="activeSection === 'registration'" class="content-section">
          <!-- <div class="section-header">
            <h3>Customer Information</h3>
            <div class="action-buttons">
              <button class="btn btn-success" *ngIf="editMode" [class.disabled]="((selectedCutomer.userAccInfo.accManager == customerForm.value.accountManager) && (selectedCutomer.userAccInfo.isActive == customerForm.value.userStatus) && (selectedCutomer.userAccInfo.uplift == customerForm.value.uplift) && (selectedCutomer.userAccInfo.title == customerForm.value.title))"
                (click)="openSubmitModal(simpleModal,'register',customerForm.value)">Save</button>
            </div>
          </div> -->

          <form [formGroup]="customerForm" class="customer-form">
            <div class="customer-info">
              <div class="section-header">
            <h3>Customer Information</h3>
            <div *ngIf="role != 'AGENT'" class="action-buttons">
              <button class="btn btn-success" *ngIf="((selectedCutomer.userAccInfo.title != customerForm.value.title))"
                (click)="openSubmitModal(simpleModal,'register',customerForm.value)">Save</button>
            </div>
          </div>
              <div class="form-grid">

                <div class="form-group w-30">
                  <label>Company Name:</label>
                  <input type="text" formControlName="companyName" readonly class="form-control"
                    >
                </div>

                <div class="form-group">
                  <label>Business Type:</label>
                  <input type="text" formControlName="businessType" readonly class="form-control"
                    >
                </div>

                <div class="form-group">
                  <label>Company Website:</label>
                  <input type="url" formControlName="companyWebsite" readonly class="form-control"
                    >
                </div>

                <div class="form-group w-10">
                  <label>Currency:</label>
                  <input type="text" [value]="selectedCutomer.walletInfo.currency" readonly class="form-control readonly">
                </div>

                <div class="form-group w-25">
                  <label>Location:</label>
                  <input type="text" formControlName="location" readonly class="form-control"
                    >
                </div>

                <div class="form-group w-25">
                  <label>Phone Number:</label>
                  <input type="tel" formControlName="phone" readonly class="form-control"
                    >
                </div>


                <div class="form-group ">
                  <label>Company Registration No.:</label>
                  <input type="text" [value]="selectedCutomer.userAccInfo.companyRegistrationNumber" readonly
                    class="form-control readonly">
                </div>

                <div class="form-group w-10">
                  <label>Title:</label>
                  <input type="text" formControlName="title" class="form-control"
                    >
                </div>

                <div class="form-group w-25">
                  <label>First Name:</label>
                  <input type="text" formControlName="firstName" readonly class="form-control"
                    >
                </div>

                <div class="form-group w-25">
                  <label>Last Name:</label>
                  <input type="text" formControlName="lastName" readonly class="form-control"
                    >
                </div>

                <div class="form-group ">
                  <label>Email:</label>
                  <input type="email" formControlName="email" readonly class="form-control"
                    >
                </div>

              </div>
            </div>
            <div class="customer-info my-4">
              <div class="section-header">
            <h3>Account Information</h3>
            <div *ngIf="role != 'AGENT'" class="action-buttons">
              <button class="btn btn-success" *ngIf="((selectedCutomer.userAccInfo.accManager != customerForm.value.accountManager) || (selectedCutomer.userAccInfo.isActive != customerForm.value.userStatus) || (selectedCutomer.userAccInfo.uplift != customerForm.value.uplift))"
                (click)="openSubmitModal(simpleModal,'register',customerForm.value)">Save</button>
            </div>
          </div>
              <div class="form-grid">

                <div class="form-group w-18">
                  <label>User Activation:</label>
                  <!-- <span class="status-badge" [class]="getStatusClass(customer.userActivation)">
                      {{ customer.userActivation }}
                    </span> -->
                  <ng-select class="form-control custom-ng-select" [searchable]="false" formControlName="userStatus"
                    [items]="userStatus" bindValue="value" bindLabel="name"></ng-select>
                </div>

                <div class="form-group w-15">
                  <label>Last Login:</label>
                  <input type="text" [value]="selectedCutomer.userAccInfo.lastLogin | date: 'dd MMM yyyy'" readonly
                    class="form-control readonly">
                </div>

                <div class="form-group w-15">
                  <label>Created Date:</label>
                  <input type="text" [value]="selectedCutomer.userAccInfo.createdOn | date: 'dd MMM yyyy'" readonly
                    class="form-control readonly">
                </div>

                <div class="form-group w-12">
                  <label>Customer ID:</label>
                  <input type="text" [value]="selectedCutomer.userAccInfo.userId" readonly class="form-control readonly">
                </div>

                <div class="form-group w-10">
                  <label>Uplift:</label>
                  <input type="text" (keypress)="onlyNumbers($event,'uplift')" (paste)="onlyNumbers($event,'uplift')" formControlName="uplift" class="form-control"
                    >
                </div>

                <div [class.disabled]="selectedCutomer.userAccInfo.role != 'USER'" class="form-group w-25">
                  <label>Account Manager:</label>
                  <ng-select formControlName="accountManager" [items]="allAgents" bindLabel="name" bindValue="id" (click)="getAgentList()" class="form-control custom-ng-select" ></ng-select>
                </div>

              </div>
            </div>
            <div class="customer-info">
              <div class="section-header">
            <h3>No. of Bookings</h3>
            <!-- <div class="form-grid"> -->
              <div class="form-group">
                <!-- <label>No. of Bookings:</label> -->
                <input type="number" [value]="selectedCutomer.bookingInfo.totalBookings" readonly
                  class="form-control readonly">
              </div>
            <!-- </div> -->
          </div>
          <div class="stats-grid">
            <div class="stat-card confirmed">
              <label>Confirmed:</label>
              <span>{{ this.selectedCutomer.bookingInfo.confirmedBookings }}</span>
            </div>
            <div class="stat-card failed">
              <label>Failed:</label>
              <span>{{ this.selectedCutomer.bookingInfo.failedBookings }}</span>
            </div>
            <div class="stat-card cancelled">
              <label>Cancelled:</label>
              <span>{{ this.selectedCutomer.bookingInfo.cancelledBookings }}</span>
            </div>
            <div class="stat-card paid">
              <label>Total Paid Amount:</label>
              <span>{{ this.selectedCutomer.bookingInfo.totalPaidAmount | currency: selectedCutomer.bookingInfo.currency
                }}</span>
            </div>
            <div class="stat-card unpaid">
              <label>Total Unpaid Amount:</label>
              <span>{{ this.selectedCutomer.bookingInfo.totalUnpaidAmount | currency:
                selectedCutomer.bookingInfo.currency }}</span>
            </div>
            <div *ngIf="role != 'AGENT'" class="stat-card profit">
              <label>Profit:</label>
              <span>{{ this.selectedCutomer.bookingInfo.profit | currency: selectedCutomer.bookingInfo.currency }}</span>
            </div>
          </div>
            </div>
          </form>

        </div>

        <!-- Wallet Section -->
        <div *ngIf="activeSection === 'wallet'" class="content-section">
          <div class="section-header">
            <h3>Wallet Requests</h3>
            <div *ngIf="role != 'AGENT'" class="gradient-border">
              <button class="btn btn-primary" (click)="openModal(addRequest, 'modal-lg')">Add Request</button>
            </div>
          </div>

          <div class="table-container">
            <table class="data-table">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody *ngIf="selectedCutomer?.walletInfo?.walletRequests?.length > 0; else noWalletRequests">
                <tr *ngFor="let request of selectedCutomer?.walletInfo?.walletRequests">
                  <td>{{ request.request }}</td>
                  <td>+ {{ request.amount | currency: request.currency }}</td>
                  <td>
                    <span class="status-badge" [class]="getStatusClass(request.status)">
                      {{ request.status }}
                    </span>
                  </td>
                  <td>{{ request.createdOn | date: 'dd/MM/yyyy' }}</td>
                  <td [class.disabled]="role == 'AGENT'" class="d-flex justify-content-center" *ngIf="request.status === 'Pending'">
                    <div  class="walletButtons d-flex">
                      <button class="btn btn-sm btn-success-check me-2"
                        (click)="openSubmitModal(simpleModal, 'walletStatus', request,'Approved')"><i
                          class="fa-solid fa-check"></i></button>
                      <button class="btn btn-sm btn-danger"
                        (click)="openSubmitModal(simpleModal, 'walletStatus', request,'Rejected')"><i
                          class="fa-solid fa-xmark"></i></button>
                    </div>
                  </td>
                  <td *ngIf="request.status !== 'Pending'">{{request.status}} on {{request?.updatedOn | date: 'dd MMM'}}
                  </td>
                </tr>
              </tbody>
              <ng-template #noWalletRequests>
                <tr class="">
                  <td colspan="5" class="text-center py-3">No wallet requests found.</td>
                </tr>
              </ng-template>
            </table>
          </div>

          <!-- Transaction History -->
          <div class="transaction-history">
            <h4>Transaction History</h4>
            <div *ngIf="selectedCutomer?.walletInfo?.transactionHistory.length > 0; else noTransactions" class="transaction-list">
              <div *ngFor="let transaction of selectedCutomer?.walletInfo?.transactionHistory" class="transaction-item">
                <div class="d-flex transaction-image">
                  <div *ngIf="transaction.hotelImage"><img [src]="transaction.hotelImage" /></div>
                  <div class="transaction-info w-100">
                    <strong class="ellipsis">{{ transaction.hotelName }}</strong>
                    <span class="transaction-id">Booked on {{ transaction.bookedOn | date: 'dd MMM yyyy' }}</span>
                  </div>
                </div>
                <div class="transaction-status">
                  <span class="status-badge text-center" [class]="getStatusClass(transaction.bookingStatus)">
                    {{ transaction.bookingStatus }}
                  </span>
                </div>
                <div class="transaction-amount">{{ transaction.price | currency: transaction.currency}}</div>
              </div>
            </div>
            <ng-template #noTransactions>
              <div class="text-center">No transactions found.</div>
            </ng-template>
          </div>
        </div>

        <!-- User Search History -->
        <div *ngIf="activeSection === 'user-search'" class="content-section">
          <div class="section-header">
            <h3>User Search History</h3>
            <div class="search-info">
              <div *ngIf="!allowAddRemoval" class="gradient-border">
                <button class="btn btn-primary">Last Search</button>
              </div>
              <div *ngIf="!allowAddRemoval" class="gradient-border">
                <button class="btn btn-primary">Your Last Download</button>
              </div>
            </div>
          </div>

          <div *ngIf="selectedCutomer.userSearchHistory.recentSearches.length > 0; else noSearchHistory" class="search-history-list">
            <div *ngFor="let search of selectedCutomer.userSearchHistory.recentSearches" class="search-item">
              <div class="d-flex">
                <div *ngIf="search.hotelImage" class="transaction-image">
                  <img [src]="search.hotelImage" />
                </div>
                <div class="search-details">
                  <strong>{{ search.hotelName }}</strong>
                  <span class="search-date">{{ search.checkInDate }} - {{ search.checkOutDate }}</span>
                  <span class="search-id">{{ calculateGuestsDisplay(search.rooms) }}</span>
                </div>
              </div>
              <!-- <button class="btn btn-sm btn-primary">></button> -->
            </div>
          </div>
          <ng-template #noSearchHistory>
            <div class="text-center">No search history found.</div>
          </ng-template>
        </div>

        <!-- User Active Request -->
        <div *ngIf="activeSection === 'user-request'" class="content-section">
          <div class="section-header">
            <h3>User Active Request</h3>
          </div>

          <div class="table-container">
            <table class="data-table">
              <thead>
                <tr>
                  <th>REQ NO.</th>
                  <th>QUERY TYPE</th>
                  <th>STATUS</th>
                  <th>DATE</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let activity of userActivities">
                  <td>{{ activity.reqNo }}</td>
                  <td>{{ activity.queryType }}</td>
                  <td>
                    <span class="status-badge" [class]="getStatusClass(activity.status)">
                      {{ activity.status }}
                    </span>
                  </td>
                  <td>{{ formatDate(activity.date) }}</td>
                  <td>
                    <button class="btn btn-sm btn-outline">{{ activity.action }}</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div *ngIf="activeSection === 'active-suppliers'" class="content-section">
          <div class="section-header">
            <h3>Active Suppliers</h3>
            <div *ngIf="!allowAddRemoval && role != 'AGENT'" class="gradient-border">
              <button class="btn btn-primary" (click)="onSupplierAction()">Add/Remove Supplier</button>
            </div>
            <button *ngIf="allowAddRemoval" (click)="onSupplierAction()" class="btn btn-success">Done</button>
          </div>

          <div class="supplier-container">
            <ng-container *ngFor="let supplier of selectedCutomer.allSuppList; let i = index">
              <div *ngIf="supplier.isActive" class="supplier-card ">
                <div class="supplier-details">
                  <img [src]="supplier.logo" alt="{{ supplier.supplierName }}" class="supplier-logo" />
                  <!-- <h4>{{ supplier.supplierName }}</h4> -->
                </div>
                <button  *ngIf="supplier.isActive && allowAddRemoval"
                  (click)="openSubmitModal(simpleModal,'removeSupplier', supplier)" class="remove-supplier"><i
                    class="fa-solid fa-xmark"></i></button>
              </div>
              <div *ngIf="(i == selectedCutomer.allSuppList.length-1) && allowAddRemoval" class="supplier-details add-supplier">
                <button (click)="openModal(supplierModal, 'modal-xl')" class="btn btn-success">+Add</button>
                <!-- <h4>{{ supplier.supplierName }}</h4> -->
              </div>

            </ng-container>
          </div>
        </div>

        <!-- Account Info -->
        <div *ngIf="activeSection === 'setup'" class="content-section set-up-form">
          <div class="section-header">
            <h3>Onboarding Information</h3>
            <div class="gradient-border">
              <button class="btn btn-primary" (click)="viewMasterAgreement(clientAgreement)">View Master
                Agreement</button>
            </div>
          </div>
          <form [formGroup]="onboardingForm" class="account-form">
            <div class="form-group w-25">
              <mat-form-field appearance="outline">
                <mat-label>Date</mat-label>
              <!-- <input type="text" placeholder="Datepicker" class="form-control" bsDatepicker> -->
              <input matInput type="text" placeholder="Date" formControlName="date" #dp="bsDatepicker" bsDatepicker
                [bsConfig]="{showWeekNumbers: false, dateInputFormat: 'DD/MM/YYYY'}" />
            </mat-form-field>
            <div class="error-message" *ngIf="onboardingForm.controls['date'].invalid
                     && (onboardingForm.controls['date'].dirty
                     || onboardingForm.controls['date'].touched)">
                <p class="text-danger">Date is required</p>
              </div>
            </div>


            <div class="form-section">
              <div class="setup-head">
                <h4 class="mb-0">Company Name (Commercial information: How the company is known and commercial address)</h4>
              </div>
              <div class="mt-4 form-row">
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>Trading Name</mat-label>
                  <input matInput type="text" formControlName="tradingName" />
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['tradingName'].invalid
                         && (onboardingForm.controls['tradingName'].dirty
                         || onboardingForm.controls['tradingName'].touched)">
                    <p class="text-danger">Trading name is required</p>
                  </div>
                </div>
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>Name of Owner / Partner(s)</mat-label>
                  <input matInput type="text" formControlName="ownerName" />
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['ownerName'].invalid
                         && (onboardingForm.controls['ownerName'].dirty
                         || onboardingForm.controls['ownerName'].touched)">
                    <p class="text-danger">Owner name is required</p>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>Address</mat-label>
                  <input matInput type="text" formControlName="address" />
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['address'].invalid
                         && (onboardingForm.controls['address'].dirty
                         || onboardingForm.controls['address'].touched)">
                    <p class="text-danger">Address is required</p>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <!-- <mat-form-field appearance="outline">
                         <mat-label>Country</mat-label>
                         <mat-select [formControl]="countryCtrl">
                             <mat-option>
                                 <input
                                 matInput
                                 placeholder="Search..."
                                 [(ngModel)]="countryFilter"
                                 (click)="$event.stopPropagation()"
                                 />
                             </mat-option>
                             <mat-option [value]="null">Select country</mat-option>
                             <mat-option *ngFor="let c of national()" [value]="c.countryCode">
                                 {{ c.countryName }}
                             </mat-option>
                         </mat-select>
                     </mat-form-field> -->
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>Country</mat-label>
                  <!-- <mat-form-field appearance="outline" class="col-md-4"> -->
                  <!-- <mat-icon matPrefix fontIcon="info" class="orange-color"></mat-icon> -->
                  <input matInput formControlName="country" type="text" required
                    (input)="onCountryInput($event)" matInput [matAutocomplete]="nationalAutoComplete">
                  <!-- <mat-autocomplete #nationalAutoComplete="matAutocomplete"> -->
                  <!-- <option *ngFor="let x of filteredNationalities | async" [value]="x?.countryName + ' - ' + x?.countryCode" (click)="onSelectNationality(x?.countryCode)">
                                     {{x?.countryName}} - {{x?.countryCode}}
                                     </option> -->
                  <!-- </mat-autocomplete> -->
                  <!-- Error Message -->
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['country'].invalid
                                     && (onboardingForm.controls['country'].dirty
                                     || onboardingForm.controls['country'].touched)">
                    <!-- <mat-icon matPrefix fontIcon="info" class="to-red-600 mr-1"></mat-icon> -->
                    <p class="text-danger">Country is required</p>
                  </div>
                  <!-- </mat-form-field> -->
                </div>
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>Business Type</mat-label>
                  <input matInput type="text" formControlName="businessType" />
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['businessType'].invalid
                         && (onboardingForm.controls['businessType'].dirty
                         || onboardingForm.controls['businessType'].touched)">
                    <p class="text-danger">Business Type is required</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-section">
              <div class="d-flex justify-content-between align-items-center setup-head">
                <div class="">
                  <h4 class="mb-0">Invoicing information: (The one that should appear in agreements and invoices)</h4>
                </div>

                <!-- ✅ Checkbox: Finance ← Operations -->
                <div class="label-class">
                  <label class="checkbox d-inline-flex align-items-center gap-2 mb-2 ms-3">
                    <input type="checkbox" [(ngModel)]="invSameAsCompany" [ngModelOptions]="{standalone:true}"
                    (ngModelChange)="toggleSectionSameAs(companyToInvoiceMap, $event)">
                  <span>Same as above (Company)</span>
                  </label>
                </div>
              </div>

              <div class="mt-4 form-row">
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>Company name</mat-label>
                  <input matInput type="text" formControlName="invoiceCompanyName" />
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['invoiceCompanyName'].invalid
                         && (onboardingForm.controls['invoiceCompanyName'].dirty
                         || onboardingForm.controls['invoiceCompanyName'].touched)">
                    <p class="text-danger">Company name is required</p>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>Fiscal/VAT/Legal number to be included on the invoice</mat-label>
                  <input matInput type="text"
                    formControlName="fiscalNumber" />
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['fiscalNumber'].invalid
                         && (onboardingForm.controls['fiscalNumber'].dirty
                         || onboardingForm.controls['fiscalNumber'].touched)">
                    <p class="text-danger">Fiscal number is required</p>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>Taxpayer Registration Number (TRN)</mat-label>
                  <input matInput type="text" formControlName="trn" />
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['trn'].invalid
                         && (onboardingForm.controls['trn'].dirty
                         || onboardingForm.controls['trn'].touched)">
                    <p class="text-danger">TRN is required</p>
                  </div>
                </div>
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>Country</mat-label>
                  <input matInput type="text"  formControlName="invoiceCountry" matInput
                    [matAutocomplete]="nationalAutoComplete" (input)="onInvoiceCountryInput($event)" />
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['invoiceCountry'].invalid
                         && (onboardingForm.controls['invoiceCountry'].dirty
                         || onboardingForm.controls['invoiceCountry'].touched)">
                    <p class="text-danger">Country is required</p>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>Address</mat-label>
                  <input matInput type="text" formControlName="invoiceAddress" />
                  <mat-autocomplete #nationalAutoComplete="matAutocomplete"
                    (optionSelected)="onCountrySelected($event.option.value)">
                    <mat-option *ngFor="let x of filteredNationalities | async"
                      [value]="x?.countryName + ' - ' + x?.countryCode">
                      {{ x?.countryName }} - {{ x?.countryCode }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['invoiceAddress'].invalid
                         && (onboardingForm.controls['invoiceAddress'].dirty
                         || onboardingForm.controls['invoiceAddress'].touched)">
                    <p class="text-danger">Address is required</p>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>Email where to send invoices and statements</mat-label>
                  <input matInput type="email"
                    formControlName="invoiceEmail" />
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['invoiceEmail'].invalid
                         && (onboardingForm.controls['invoiceEmail'].dirty
                         || onboardingForm.controls['invoiceEmail'].touched)">
                    <p class="text-danger">Email is required</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-section">
              <div class="setup-head">
                <h4 class="mb-0">Contact Details (Commercial Contact Details)</h4>
              </div>

              <div class="mt-4 form-row">
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>Name</mat-label>
                  <input matInput type="text" formControlName="commercialName" />
                </mat-form-field>
                <div class="error-message mb-0" *ngIf="onboardingForm.controls['commercialName'].invalid
                         && (onboardingForm.controls['commercialName'].dirty
                         || onboardingForm.controls['commercialName'].touched)">
                    <p class="text-danger">Name is required</p>
                  </div>
                </div>
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>Position</mat-label>
                  <input matInput type="text" formControlName="commercialPosition" />
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['commercialPosition'].invalid
                         && (onboardingForm.controls['commercialPosition'].dirty
                         || onboardingForm.controls['commercialPosition'].touched)">
                    <p class="text-danger">Position is required</p>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>Phone (Direct Line)</mat-label>
                  <input matInput type="text" formControlName="commercialPhone" />
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['commercialPhone'].invalid
                         && (onboardingForm.controls['commercialPhone'].dirty
                         || onboardingForm.controls['commercialPhone'].touched)">
                    <p class="text-danger">Phone is required</p>
                  </div>
                </div>
                <div class="form-subgroup">
                  <ngx-intl-tel-input formControlName="commercialMobile"
                    [preferredCountries]="[CountryISO.UnitedKingdom, CountryISO.UnitedArabEmirates, CountryISO.UnitedStates]"
                    [enablePlaceholder]="true"
                    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name, SearchCountryField.DialCode]"
                    [searchCountryFlag]="true" [separateDialCode]="true" [phoneValidation]="true">
                  </ngx-intl-tel-input>
                  <div class="error-message" *ngIf="shouldShow('commercialMobile')">
                    <p class="text-danger" *ngIf="firstError('commercialMobile') === 'required'">
                      Mobile is required
                    </p>
                    <p class="text-danger" *ngIf="firstError('commercialMobile') === 'validatePhoneNumber'">
                      Invalid number
                    </p>
                  </div>


                </div>
              </div>

              <div class="form-row">
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>E-mail</mat-label>
                  <input matInput type="email" formControlName="commercialEmail" />
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['commercialEmail'].invalid
                         && (onboardingForm.controls['commercialEmail'].dirty
                         || onboardingForm.controls['commercialEmail'].touched)">
                    <p class="text-danger">E-mail is required</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Operations Contact Details -->
            <div class="form-section">
              <div class="d-flex justify-content-between align-items-center setup-head">
                <div class="">
                  <h4 class="mb-0">Operations Contact Details</h4>
                </div>

                <!-- ✅ Checkbox: Operations ← Commercial -->
                <div class="label-class">
                  <label class="checkbox d-inline-flex align-items-center gap-2 mb-2">
                    <input type="checkbox" [(ngModel)]="opsSameAsCommercial" [ngModelOptions]="{standalone:true}"
                      (ngModelChange)="toggleSectionSameAs(commercialToOperationsMap, $event)">
                    <span>Same as above (Commercial)</span>
                  </label>
                </div>
              </div>

              <div class="mt-4 form-row">
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>Name</mat-label>
                  <input matInput type="text" placeholder="Name" formControlName="operationsName" />
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['operationsName'].invalid
                         && (onboardingForm.controls['operationsName'].dirty
                         || onboardingForm.controls['operationsName'].touched)">
                    <p class="text-danger">Name is required</p>
                  </div>
                </div>
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>Position</mat-label>
                  <input matInput type="text" formControlName="operationsPosition" />
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['operationsPosition'].invalid
                         && (onboardingForm.controls['operationsPosition'].dirty
                         || onboardingForm.controls['operationsPosition'].touched)">
                    <p class="text-danger">Position is required</p>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>Phone (Direct Line)"</mat-label>
                  <input matInput type="text" formControlName="operationsPhone" />
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['operationsPhone'].invalid
                         && (onboardingForm.controls['operationsPhone'].dirty
                         || onboardingForm.controls['operationsPhone'].touched)">
                    <p class="text-danger">Phone is required</p>
                  </div>
                </div>
                <div class="form-subgroup">
                  <ngx-intl-tel-input formControlName="operationsMobile"
                    [preferredCountries]="[CountryISO.UnitedKingdom,CountryISO.UnitedArabEmirates, CountryISO.UnitedStates]"
                    [enablePlaceholder]="true"
                    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name, SearchCountryField.DialCode]"
                    [searchCountryFlag]="true" [separateDialCode]="true" [phoneValidation]="true">
                  </ngx-intl-tel-input>
                  <div class="error-message" *ngIf="shouldShow('operationsMobile')">
                    <p class="text-danger" *ngIf="firstError('operationsMobile') === 'required'">
                      Mobile is required
                    </p>
                    <p class="text-danger" *ngIf="firstError('operationsMobile') === 'validatePhoneNumber'">
                      Invalid number
                    </p>
                  </div>


                </div>
              </div>

              <div class="form-row">
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>E-mail</mat-label>
                  <input matInput type="email" formControlName="operationsEmail" />
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['operationsEmail'].invalid
                         && (onboardingForm.controls['operationsEmail'].dirty
                         || onboardingForm.controls['operationsEmail'].touched)">
                    <p class="text-danger">E-mail is required</p>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>E-mail to receive call centre responses/notifications</mat-label>
                  <input matInput type="email"
                    formControlName="operationsNotificationEmail" />
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['operationsNotificationEmail'].invalid
                         && (onboardingForm.controls['operationsNotificationEmail'].dirty
                         || onboardingForm.controls['operationsNotificationEmail'].touched)">
                    <p class="text-danger">E-mail is required</p>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>E-mail to receive all bookings confirmations</mat-label>
                  <input matInput type="email"
                    formControlName="operationsBookingEmail" />
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['operationsBookingEmail'].invalid
                         && (onboardingForm.controls['operationsBookingEmail'].dirty
                         || onboardingForm.controls['operationsBookingEmail'].touched)">
                    <p class="text-danger">E-mail is required</p>
                  </div>
                </div>
              </div>
            </div>


            <!-- Finance Contact Details -->
            <div class="form-section">
              <div class="d-flex justify-content-between align-items-center setup-head">
                <div class="">
                  <h4 class="mb-0" >Finance Contact Details</h4>
                </div>

                <!-- ✅ Checkbox: Finance ← Operations -->
                <div class="label-class">
                  <label class="checkbox d-inline-flex align-items-center gap-2 mb-2 ms-3">
                    <input type="checkbox" [(ngModel)]="finSameAsOperations" [ngModelOptions]="{standalone:true}"
                      (ngModelChange)="toggleSectionSameAs(operationsToFinanceMap, $event)">
                    <span>Same as above (Operations)</span>
                  </label>
                </div>
              </div>

              <div class="mt-4 form-row">
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>Name</mat-label>
                  <input matInput type="text" formControlName="financeName" />
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['financeName'].invalid
                         && (onboardingForm.controls['financeName'].dirty
                         || onboardingForm.controls['financeName'].touched)">
                    <p class="text-danger">Name is required</p>
                  </div>
                </div>
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>Position</mat-label>
                  <input matInput type="text" formControlName="financePosition" />
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['financePosition'].invalid
                         && (onboardingForm.controls['operationsBookingEmail'].dirty
                         || onboardingForm.controls['operationsBookingEmail'].touched)">
                    <p class="text-danger">Position is required</p>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>Phone (Direct Line)</mat-label>
                  <input matInput type="text" formControlName="financePhone" />
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['financePhone'].invalid
                         && (onboardingForm.controls['financePhone'].dirty
                         || onboardingForm.controls['financePhone'].touched)">
                    <p class="text-danger">Phone is required</p>
                  </div>
                </div>
                <div class="form-subgroup">
                  <ngx-intl-tel-input formControlName="financeMobile"
                    [preferredCountries]="[CountryISO.UnitedKingdom,CountryISO.UnitedArabEmirates, CountryISO.UnitedStates]"
                    [enablePlaceholder]="true"
                    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name, SearchCountryField.DialCode]"
                    [searchCountryFlag]="true" [separateDialCode]="true" [phoneValidation]="true">
                  </ngx-intl-tel-input>
                  <div class="error-message" *ngIf="shouldShow('financeMobile')">
                    <p class="text-danger" *ngIf="firstError('financeMobile') === 'required'">
                      Mobile is required
                    </p>
                    <p class="text-danger" *ngIf="firstError('financeMobile') === 'validatePhoneNumber'">
                      Invalid number
                    </p>
                  </div>


                </div>
              </div>
              <div class="form-row">
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>E-mail</mat-label>
                  <input matInput type="email" formControlName="financeEmail" />
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['financeEmail'].invalid
                         && (onboardingForm.controls['financeEmail'].dirty
                         || onboardingForm.controls['financeEmail'].touched)">
                    <p class="text-danger">E-mail is required</p>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-subgroup">
                  <mat-form-field appearance="outline">
                    <mat-label>Address</mat-label>
                  <input matInput type="text" formControlName="financeAddress" />
                </mat-form-field>
                <div class="error-message" *ngIf="onboardingForm.controls['financeAddress'].invalid
                         && (onboardingForm.controls['financeAddress'].dirty
                         || onboardingForm.controls['financeAddress'].touched)">
                    <p class="text-danger">Address is required</p>
                  </div>
                </div>
              </div>
            </div>




            <div *ngIf="role != 'AGENT'" class="submit-btn no-print d-flex justify-content-end">
              <button class="btn btn-success" (click)="openSubmitModal(simpleModal, 'setUpForm', onboardingForm.value)"
                type="submit">Submit Set up Form</button>
            </div>

          </form>
        </div>

      </div>
    </div>
    }
  </div>
</div>

<ng-template #deletePopup>
  <div class="professional-modal-overlay">
    <div class="professional-modal-container">
      <div class="delete-modal modal-content">
        <!-- Header with professional gradient styling -->
        <div class="modal-header professional-header">
          <div class="header-icon-wrapper">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
          <h5 class="modal-title">Delete User Confirmation</h5>
          <button type="button" class="btn-close professional-close" (click)="onClose()" aria-label="Close">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <!-- Body with enhanced styling -->
        <div class="modal-body professional-body">
          <div class="warning-icon-container">
            <div class="warning-icon-bg">
              <i class="fas fa-user-times"></i>
            </div>
          </div>

          <div class="content-section">
            <h6 class="confirmation-title">Are you sure you want to delete this user?</h6>
            <div class="user-info-card">
              <strong class="user-name">{{ deletingUser?.companyName }}</strong>
            </div>
            <p class="warning-text">
              <i class="fas fa-info-circle me-2"></i>
              This action cannot be undone and will permanently remove all user data.
            </p>
          </div>
        </div>

        <!-- Footer with gradient buttons -->
        <div class="modal-footer professional-footer">
          <button type="button" class="btn btn-cancel professional-btn" (click)="onClose()">
            <i class="fas fa-arrow-left me-2"></i>
            Cancel
          </button>
          <button type="button" class="btn btn-delete professional-btn" (click)="onDeleteConfirm()">
            <i class="fas fa-trash-alt me-2"></i>
            Delete User
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #clientAgreement>
  <div #agreementScreen class="pdf-container">
    <div class=" scrollable-container">
      <div class="d-flex justify-content-center align-items-center rateloc-image">
        <img src="/assets/images/rateloc new logo 5.svg" />
      </div>
      <h4>CLIENT SERVICE AGREEMENT</h4>

      <p>
        This Client Service Agreement (the “Agreement”) is entered into as of
        <strong>{{ selectedCutomer.setUpFormInfo?.formData?.clientData?.date | date: 'dd/MM/yyyy' }}</strong> (the
        “Effective Date”) by and between:
        <strong>SFA RATELOC IT PORTAL CO</strong>, a company registered in the UAE with company no: 1353469 and
        registered office
        address Bridge Tower, 3rd Floor, Dubai Sports City, P.O. Box 392269, Dubai, UAE (hereinafter referred to as the
        “Company”).
      </p>

      <p class="text-center">AND</p>

      <p>
        <strong>{{ selectedCutomer.setUpFormInfo?.formData?.clientData?.invoiceCompanyName }}</strong>, a company
        incorporated under the laws of
        <strong>{{ selectedCutomer.setUpFormInfo?.formData?.clientData?.invoiceCountry }}</strong>, with
        TAX/Registration number
        <strong>{{ selectedCutomer.setUpFormInfo?.formData?.clientData?.fiscalNumber }}</strong> and having its
        registered office at
        <strong>{{ selectedCutomer.setUpFormInfo?.formData?.clientData?.invoiceAddress }}</strong> and represented by
        <strong>{{ selectedCutomer.setUpFormInfo?.formData?.clientData?.commercialName }}</strong>,
        contact <strong>{{ selectedCutomer.setUpFormInfo?.formData?.clientData?.commercialPhone }}</strong> (the
        “Client”).
        Together referred to as the “Parties” and individually as a “Party”.
      </p>


      <h5>1. Scope of Services </h5>
      <p>RateLoc agrees to provide the Client with access to its B2B hotel booking platform, including
        the ability to search, book, and manage hotel reservations for onward sale or internal use,
        subject to the terms and conditions herein.</p>


      <h5>2. Access and Use </h5>
      <p>2.1 The Client will be provided with login credentials to access the RateLoc system.</p>
      <p>2.2 The Client agrees: </p>
      <ul>
        <li>To use the platform solely for business purposes;</li>
        <li>To use the platform solely for business purposes;</li>
        <li>To use the platform solely for business purposes;</li>
      </ul>


      <h5>3. Client Obligations </h5>
      <p>The Client shall: </p>
      <ul>
        <li>Ensure accurate and lawful use of RateLoc’s platform;</li>
        <li>Provide accurate end-customer details at time of booking;</li>
        <li>Settle payments as per the agreed terms;</li>
        <li>Refrain from any activity that may harm RateLoc’s platform, systems, or reputation.</li>
      </ul>

      <h5>4. Booking Terms </h5>
      <p>4.1 All bookings are subject to the terms and cancellation policies of each respective
        supplier or hotel. </p>
      <p>4.2 Bookings may be non-refundable or subject to cancellation/amendment fees, which will be
        clearly stated at the time of booking. </p>
      <p>4.3 RateLoc is not responsible for inaccuracies or changes made by third-party suppliers or
        hotels. </p>

      <h5>5. Fees and Payment </h5>
      <p>5.1 RateLoc will provide the Client with net rates or commissionable prices (as agreed). </p>
      <p>5.2 The Client shall make payment: </p>
      <ul>
        <li>Either via pre-funded credit system or credit card at the time of booking; </li>
        <li>Pre loaded wallet</li>
        <li>Or on agreed credit terms, if applicable.</li>
      </ul>
      <p>5.3 Payment Deadlines and Right to Cancel </p>

      <p>All payments for bookings must be received by RateLoc no later than the specified payment
        deadline communicated at the time of booking. If full payment is not received by the stated
        deadline, RateLoc reserves the right, without further notice, to cancel the booking on
        behalf of the Client. In such cases, RateLoc shall not be held liable for any costs,
        damages, or losses incurred by the Client or their end customer due to cancellation
        resulting from non-payment. </p>

      <h5>5A. Wallet Terms (Prepaid Credit Facility) </h5>
      <p>5A.1 RateLoc offers a virtual Wallet feature where Clients can deposit prepaid funds into
        their account to facilitate instant hotel bookings. </p>
      <p>5A.2 Funds in the wallet: </p>
      <ul>
        <li>Are denominated in currency of choice </li>
        <li>Can be used exclusively to book services via RateLoc;</li>
        <li>Are non-interest bearing and non-refundable unless agreed otherwise in writing. </li>
      </ul>
      <p>5A.3 The Client is responsible for maintaining a sufficient wallet balance to make bookings.
        RateLoc is not obliged to reserve services where the wallet is underfunded.</p>
      <p>5A.4 Wallet top-ups can be made via: </p>
      <ul>
        <li>Bank transfer (subject to clearing);</li>
        <li>Credit card (fees may apply).</li>
      </ul>
      <p>5A.5 Wallet balances are visible to the Client in real time on the RateLoc dashboard. </p>
      <p>5A.6 In the event of termination or inactivity exceeding 12 months, any unused wallet balance
        may be refunded (less any applicable fees), or forfeited if dormant and unrecoverable (in
        accordance with local law and subject to prior notice). </p>
      <p>5A.7 Wallet activity, deposits, and deductions will be itemized in downloadable reports
        accessible via the RateLoc platform. </p>
      <p>5A.8 <span class="highlight">Refunds and Rebate Adjustments</span> </p>
      <p>If any Wallet funds are refunded upon request or due to account closure, RateLoc reserves the
        right to deduct any rebate, bonus, or promotional credit previously applied to the refunded
        deposit. The final refund amount will be net of such incentives. This applies regardless of
        whether the rebate was used or not.</p>
      <p>5A.8 Minimum 5000AED or equivalent is required to benefit from wallet rebate offer. </p>

      <h5>6. Liability </h5>
      <p>6.1 RateLoc acts as an intermediary and is not the provider of the accommodation. Therefore,
        RateLoc shall not be liable for service deficiencies, overbookings, or acts of the hotel or
        supplier.</p>
      <p>6.2 RateLoc’s liability is limited to the amount paid for the affected booking. </p>
      <p>6.3 RateLoc shall not be liable for indirect, special, or consequential damages.</p>


      <h5>7. Term and Termination </h5>
      <p>7.1 This Agreement commences on the Effective Date and shall continue until terminated by
        either party with 30 days’ written notice. </p>
      <p>7.2 RateLoc may terminate this Agreement immediately if the Client: </p>
      <ul>
        <li>Breaches any material obligation; </li>
        <li>Engages in fraudulent activity;</li>
        <li>Fails to settle payments on time. </li>
      </ul>

      <h5>8. Confidentiality</h5>
      <p>Both parties agree to treat as confidential all data, pricing, and system information shared
        during the term of this Agreement and not to disclose it to any third party without prior
        written consent. </p>


      <h5>9. Data Protection </h5>
      <p>Each Party agrees to comply with applicable data protection laws (including GDPR, where
        applicable) and process personal data in accordance with the Privacy Policy available at
        www.rateloc.com </p>

      <h5>10. Governing Law and Jurisdiction </h5>
      <p>This Agreement shall be governed by and construed in accordance with the laws of the Dubai
        International Financial Centre (DIFC), and the Parties agree to submit to the exclusive
        jurisdiction of the DIFC Courts. </p>

      <h5>11. Miscellaneous </h5>
      <ul>
        <li>This Agreement may not be assigned without the written consent of the other Party.</li>
        <li>Any amendments must be made in writing and signed by both Parties.</li>
        <li>This Agreement represents the entire agreement and supersedes all prior understandings.
        </li>
      </ul>

      <p>IN WITNESS WHEREOF, each of the afore-named Parties has executed this Agreement as of the
        day, month and year above first written. </p>


      <!--  <form [formGroup]="agreementForm" (ngSubmit)="sendAgreement()"> -->
      <div class="sign-div">
        <p class="firstdiv">Signed by: Shazad Abu Bakr</p>
        <p class="second-div"><span>Signed by:</span>
          <span>{{selectedCutomer.setUpFormInfo?.formData?.agreement?.client_signed_by}}</span>
        </p>
      </div>

      <div class="sign-div">
        <p class="firstdiv">Position: CEO</p>
        <p class="second-div"><span class="position">Position:</span>
          <span>{{selectedCutomer.setUpFormInfo?.formData?.agreement?.client_signed_by}}</span>
          <!--
                                        <input class="small-box" type="text" formControlName="client_signed_by">
                                        <input class="small-box" type="text" formControlName="client_position"> -->
        </p>
      </div>

      <div class="sign-div">
        <p class="firstdiv-client">For and on behalf of the <span class="fw-bold">Company</span></p>
        <p class="second-div-client">For and on behalf of the <span class="fw-bold">Client</span></p>
      </div>

      <div class="sign-div">
        <div class="firstdiv">
          <div class="sign-height">
            <input type="file" id="clientSignatureInput" accept="image/*"
              (change)="onSignatureSelected($event,'quantrol')" hidden>

            <!-- Upload button (triggers file input) -->
            <label for="clientSignatureInput">
              <img
                *ngIf="!quantrolSignaturePreview && !selectedCutomer.setUpFormInfo?.formData?.agreement?.rateloc_signature_base64"
                src="assets/images/upload icon.svg" alt="Upload Signature" class="upload-image" />
              <img
                *ngIf="quantrolSignaturePreview || selectedCutomer.setUpFormInfo?.formData.agreement?.rateloc_signature_base64"
                [src]="quantrolSignaturePreview || selectedCutomer.setUpFormInfo?.formData.agreement?.rateloc_signature_base64"
                alt="Client Signature" class="signature-preview" />
            </label>
          </div>
        </div>
        <div class="second-div-client">
          <div class="sign-height-client">
            <!-- <input type="file"
           id="clientSignatureInput"
           accept="image/*"
           (change)="onSignatureSelected($event,'client')"
           hidden> -->

            <label>
              <img [src]="selectedCutomer.setUpFormInfo?.formData?.agreement?.client_signature_base64"
                alt="Client Signature" class="signature-preview" />
            </label>
          </div>
        </div>

      </div>

      <div class="sign-div">
        <div class="firstdiv">
          <hr class="signature-line">
        </div>
        <div class="second-div-client">
          <hr class="signature-line">
        </div>
      </div>

      <div class="sign-div">
        <div class="firstdiv">
          <p>Dated: <span>{{ selectedCutomer.setUpFormInfo?.formData?.clientData?.uploadDate | date: 'dd/MM/yyyy'
              }}</span></p>
        </div>
        <div class="second-div-client">
          <p>Dated: <span>{{ selectedCutomer.setUpFormInfo?.createdOn | date: 'dd/MM/yyyy' }}</span></p>
        </div>
      </div>

      <!--   </form>  -->


    </div>
  </div>
  <div *ngIf="showButtons" class="client-buttons">
    <div class="w-50">
      <button class="btn btn-secondary close-button" (click)="onClose()">Close</button>
    </div>
    <div *ngIf="role != 'AGENT'" class="d-flex w-50 justify-content-end">

      <button class="btn orange-button me-2" *ngIf="!quantrolSignaturePreview" (click)="downloadAgreementPDF()">Download
        <i class="fa-solid fa-download"></i></button>
      <button class="btn orange-button" *ngIf="quantrolSignaturePreview"
        (click)="openSubmitModal(simpleModal, 'setUpForm', selectedCutomer.setUpFormInfo)">Upload Signature <i
          class="ms-3 fa-solid fa-upload"></i></button>
    </div>
  </div>
</ng-template>

<ng-template #supplierModal>
  <div *ngIf="activeSection === 'active-suppliers'" class="content-section add-remove-supplier">
    <div class="section-header">
      <!-- <h3>Active Suppliers</h3> -->
      <div *ngIf="!allowAddRemoval" class="gradient-border">
        <button class="btn btn-primary" (click)="onSupplierAction()">Add/Remove Supplier</button>
      </div>
      <button *ngIf="allowAddRemoval" (click)="submitSuppliers()" class="btn btn-success">Done</button>
    </div>

    <div class="supplier-container">
      <ng-container *ngFor="let supplier of selectedCutomer.allSuppList; let i as index">
        <div (click)="openSubmitModal(simpleModal,'addSupplier', supplier)" *ngIf="!supplier.isActive"
          class="supplier-card">
          <div class="supplier-details">
            <img [src]="supplier.logo" alt="{{ supplier.supplierName }}" class="supplier-logo" />
            <!-- <h4>{{ supplier.supplierName }}</h4> -->
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>


<ng-template #simpleModal>
  <div class="confirmation-modal">
    <div class="modal-header border-0 pb-0 mb-3">
      <div class="w-100 text-center">
        <div class="modal-icon position-absolute ">
          <i class="bi bi-exclamation-triangle-fill text-warning" style="font-size: 3rem;"></i>
        </div>
        <div class="confirmation-title mb-2">
          <h4 class="modal-title  fw-bold text-dark mb-2">
            Confirm Your Changes
          </h4>
        </div>
        <p class="text-muted mb-0">
          You are about to update <strong>{{ activeSection == 'registration' ? 'Account Details' : activeSection == 'wallet' ? 'Wallet' : activeSection == 'active-suppliers' ? 'Active Suppliers' : 'Setup Form' }}</strong>. Please review the changes below.
        </p>
      </div>
      <button type="button" class="btn-close position-absolute" style="top: 15px; right: 15px;"
        (click)="onClose()"></button>
    </div>

    <div class="modal-body py-2 px-5">

      <div class="changes-container">
        <div *ngIf="activeSection == 'registration'" class="change-item">
          <div class="change-controls">
            <div *ngIf="selectedCutomer.userAccInfo.isActive != selectedValue.userStatus" class="change-control ">
              <h5>User Status: </h5>
              <span [ngClass]="{'text-success': selectedValue.userStatus == 2, 'text-warning': selectedValue.userStatus == 1, 'text-danger': selectedValue.userStatus == 0}" >{{ selectedValue.userStatus == 2 ? 'Active' : selectedValue.userStatus == 0 ? 'Inactive' : 'Partial Active' }}</span>
            </div>
            <div *ngIf="selectedCutomer.userAccInfo.accManager != selectedValue.accountManager" class="change-control ">
              <h5>Account Manager: </h5>
              <span>{{ selectedValue.accountManager}}</span>
            </div>
            <div *ngIf="selectedCutomer.userAccInfo.uplift != selectedValue.uplift" class="change-control ">
              <h5>Uplift: </h5>
              <span>{{ selectedValue.uplift}}</span>
            </div>
            <div *ngIf="selectedCutomer.userAccInfo.title != selectedValue.title" class="change-control mt-3 ">
              <h5>Title: </h5>
              <span>{{ selectedValue.title}}</span>
            </div>
          </div>
        </div>
        <div *ngIf="activeSection == 'active-suppliers'" class="change-item">
          <div class="supplier-card ">
            <div class="supplier-details d-flex align-items-center py-1">
              <div class="w-25">{{selectedFlag ==
            'removeSupplier' ? 'Supplier Removed' : 'Supplier Added'}}:</div>
              <img [src]="selectedValue?.logo" alt="{{ selectedValue.supplierName }}" class="supplier-logo" />
              <!-- <h4>{{ supplier.supplierName }}</h4> -->
            </div>
          </div>
        </div>
        <div *ngIf="activeSection == 'wallet'" class="change-item">
          <div class="supplier-card ">
            <div class="supplier-details py-3">
              Are you sure you want to <span
                [ngStyle]="{'color': (selectedValue?.walletAction == 'Approved' || selectedFlag == 'addAmount')  ? '#a2c030' : 'red' }">{{
                (selectedValue?.walletAction == 'Approved' || selectedFlag == 'addAmount') ? 'Approve' : 'Reject' }}</span>  <strong> a wallet request of {{
                  selectedFlag == 'addAmount' ? selectedValue : selectedValue?.amount | currency: selectedCutomer.walletInfo.currency :'symbol':'1.0-0' }} ?</strong>
              <!-- <h4>{{ supplier.supplierName }}</h4> -->
            </div>
          </div>
        </div>
        <div *ngIf="activeSection == 'setup'" class="change-item">
          <div class="supplier-card ">
            <div class="supplier-details py-3">
              Are you sure you want to <strong> save Setup Form Changes ?</strong>
              <!-- <h4>{{ supplier.supplierName }}</h4> -->
            </div>
          </div>
        </div>
      </div>

      <div class="p-3 py-2">
        <div class="d-flex align-items-start notes">
          <i class="bi bi-lightbulb text-warning me-2 mt-1"></i>
          <div>
            <small class="">
              <strong>Note:</strong> These changes will be saved immediately after confirmation.
              Make sure all information is correct before proceeding.
            </small>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer border-0 pt-0 px-5">
      <div class="d-flex justify-content-between gap-3 w-100">
        <button type="button" class="btn btn-outline-secondary cancel-change px-4" (click)="onClose()">
          <i class="bi bi-x-circle me-2"></i>
          Cancel Changes
        </button>
        <button type="button" (click)="onSubmit()" class="btn btn-success px-4">
          <i class="bi bi-check2-circle me-2"></i>
          Confirm & Save
        </button>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #addRequest>
  <div class="add-request">
    <div class="ar-header">
      <h4>How much money would you like to add?</h4>
    </div>
    <div class="ar-body px-4">
      <mat-form-field floatLabel="always" >
        <!-- <mat-label>Amount</mat-label> -->
        <input matInput type="text" (keypress)="onlyNumbers($event)" [(ngModel)]="reqAmount" class="example-right-align" placeholder="0.00" />
        <span matTextSuffix>{{selectedCutomer.walletInfo.currency}}&nbsp;</span>
        <!-- <span matTextSuffix>.00</span> -->
      </mat-form-field>
    </div>
    <div class="modal-footer ar-footer border-0 pt-0 px-4">
      <div class="d-flex justify-content-between gap-3 w-100">
        <button type="button" class="btn btn-outline-secondary cancel-change px-4" (click)="onClose()">
          <i class="bi bi-x-circle me-2"></i>
          Cancel Changes
        </button>
        <button type="button" (click)="openSubmitModal(simpleModal,'addAmount',reqAmount)" class="btn btn-success px-4">
          <i class="bi bi-check2-circle me-2"></i>
          Confirm
        </button>
      </div>
    </div>
  </div>
</ng-template>
